var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#3787FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.33398,
    y: 5.33337,
    width: 5.83333,
    height: 5.83333,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.834 6.83338C12.834 6.00495 13.5056 5.33337 14.334 5.33337H17.1673C17.9957 5.33337 18.6673 6.00495 18.6673 6.83337V9.66671C18.6673 10.4951 17.9957 11.1667 17.1673 11.1667H14.334C13.5056 11.1667 12.834 10.4951 12.834 9.66671V6.83338ZM5.33398 14.3334C5.33398 13.5049 6.00556 12.8334 6.83398 12.8334H9.66732C10.4957 12.8334 11.1673 13.5049 11.1673 14.3334V17.1667C11.1673 17.9951 10.4957 18.6667 9.66732 18.6667H6.83399C6.00556 18.6667 5.33398 17.9951 5.33398 17.1667V14.3334ZM14.334 12.8334C13.5056 12.8334 12.834 13.5049 12.834 14.3334V17.1667C12.834 17.9951 13.5056 18.6667 14.334 18.6667H17.1673C17.9957 18.6667 18.6673 17.9951 18.6673 17.1667V14.3334C18.6673 13.5049 17.9957 12.8334 17.1673 12.8334H14.334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapActive);
export default __webpack_public_path__ + "static/media/map-active.ac9dd7bc484aad17fe9403d03e433d4b.svg";
export { ForwardRef as ReactComponent };